/*产品展示item*/
import { getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import { filter, union, isEmpty } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { Loading } from '../../components';
import { Box, IconButton } from '@mui/material';
import './productsView.css';
import { MoreHoriz } from '@mui/icons-material';
import { getProductImage } from '@ivymobi/orbit-core';

const ProductItem = (props) => {
  const user = useContext(UserContext);
  const tenant = useContext(TenantContext);
  const {item, setSelectInfo} = props;
  const _item = {name:'', imgUrl:''};
  if (item.type ==='catalog') {
    _item.name = item.cgName?.zh;
    _item.imgUrl = getProductImage(item?.mime,'/images/catlog.svg') ;
  } else if (item.type==='product') {
    _item.name = item.details?.descriptionShort?.zh;
    _item.imgUrl = getProductImage(item?.mime,'/images/dproduct.svg');
  }
  return (
    <Box className="productItemPd">   
      <Box className="productItem"  >   
        <Box onClick={() => {props.onClick(item.id, _item.name, item.type, item.csName);}} style={{width:'100%', height: '218px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <img 
            src={_item.imgUrl}  
            style={{
              objectFit: 'contain', 
              padding: '8px', 
              width: '100%',
              height: '100%'
            }}
          />
        </Box>
        <Box style={{
          width:'100%',
          height: '30px',
          backgroundColor: '#e5e5e5',
          display: 'flex',
          alignItems: 'center'
        }} onClick={() => {
          props.onClick(item.id, _item.name, item.type, item.csName);
        }}>
          <Box style={{
            fontSize:'14px', 
            whiteSpace:'nowrap', 
            textOverflow:'ellipsis', 
            overflow:'hidden',
            padding: '0 5px'}}
          >
            {_item.name}
          </Box>
        </Box>

        <Box style={{ position: 'absolute', left: 0, bottom: '30px', width:'100%', height:'30px', display:'flex', justifyContent:'flex-end'}}>
          {(!isEmpty(user)||(window.self!=window.top)||window.WeixinJSBridge) && <IconButton
            onClick={(e) => {
              setSelectInfo({show:true, item:item, target:e.target}); 
              }}
            size="large">
            <MoreHoriz />
          </IconButton>}
        </Box>
      </Box>
    </Box>
  ); 
};

export default ProductItem;